import { call, put } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";
import { Auth } from "aws-amplify";

import { storeCognitoInfo } from "../../helpers";
import * as MiniMessageBox from "../../../../MiniMessageBox";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* authnzCognitoLogin(arg0: { email: string; password: string }): Generator<any, any, any> {
  const { email, password } = arg0;
  return yield Auth.signIn(email.trim().toLowerCase(), password);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzUserLoginWorker({ payload, navigate }: Record<string, any>): Generator<any, any, any> {
  const form = "LoginForm";
  const { userIsGoingTo } = payload;

  try {
    yield put(startSubmit(form));

    const data = yield call(authnzCognitoLogin, payload);

    yield put(stopSubmit(form));

    yield put(MiniMessageBox.hideMiniBoxMessage());

    if (data.challengeName === "NEW_PASSWORD_REQUIRED") {
      yield storeCognitoInfo(data);
      navigate("/login/set-password");
    } else {
      payload.logLoginEvent && payload.logLoginEvent(true);

      /* sets the logged in session key, This is just a key that we
         will check to keep people logged in */
      sessionStorage.setItem("loggedIn", "true");

      yield payload.onStateChange("signedIn", {});
      if (userIsGoingTo) {
        navigate(userIsGoingTo);
      } else {
        navigate("/");
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    payload.logLoginEvent && payload.logLoginEvent(false);
    yield put(stopSubmit(form));
    if (error["code"] === "UserNotConfirmedException") {
      navigate(`/confirm?email=${encodeURIComponent(payload.email.toLowerCase())}`);
    } else if (error["message"]) {
      yield put(MiniMessageBox.showMiniBoxMessage({ show: true, type: "error", message: error.message }));
    }
  }
}
